
import { computed, defineComponent, PropType, Ref } from 'vue';
import HeroBanner from '@/shared/content/blocks/hero-banner/HeroBanner.vue';
import { HeroBannerBlocksTileModel, ImageFileModel } from '@/types/B2BcontentServerContract';
import utils from '@/shared/utilities.service';
import constants from '@/shared/config/constants';
import BlockList from '@/shared/content/blocks/helpers/BlockList.vue';

export default defineComponent({
    name: 'HeroBannerBlocksTile',
    components: { BlockList, HeroBanner },
    props: {
        content: {
            type: Object as PropType<HeroBannerBlocksTileModel>,
            required: true,
        },
    },
    setup(props) {
        const isImageType = computed((): boolean => {
            return props.content?.media.type === constants.media.imageModel ?? false;
        });

        const image: Ref<ImageFileModel> = computed(() => {
            return isImageType.value ? props.content.media.model : props.content.media.model.image;
        });

        const vimeoId = computed((): number | undefined => {
            return utils.ifMediaModelIsVideoReturnIdFromVimeoUrl(props.content.media);
        });

        return {
            image,
            isImageType,
            vimeoId,
        };
    },
});
